<template>
  <el-container>
    <el-form ref="infoForm" :model="ruleForm" label-width="120px" :rules="rules">
      <el-form-item label="用户账号" prop="login_name">
        <el-input v-model="ruleForm.login_name" disabled></el-input>
      </el-form-item>
      <el-form-item label="用户名称" prop="user_name">
        <el-input v-model="ruleForm.user_name"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="user_gender">
        <el-select v-model="ruleForm.user_gender">
          <el-option
            v-for="item in userGenderList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="mail">
        <el-input v-model="ruleForm.mail"></el-input>
      </el-form-item>

      <el-form-item
        label="头像"
        style="text-align: left"
        prop="head_image">
        <el-upload
          class="avatar-uploader"
          :action="uploadAction"
          :show-file-list="false"
          :on-success="handleImageSuccess"
          :before-upload="beforeHeadUpload">
          <img
            v-if="share.head_image"
            :src="share.head_image"
            class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item style="text-align: left;">
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog qd" @click="handleModifyInfo">确认修改</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import RightHelper from '@/api/right_helper'

export default {
  name: '',
  data () {
    return {
      uploadAction: Backend.BACKENDURL + '/admin/upload/head_image',
      userGenderList: BasicDataHelper.UserGenderList,
      share: {
        head_image: undefined
      },
      rules: {
        login_name: [
          { required: true, message: '请输入用户账号', trigger: 'blur' },
          {
            pattern: /^[\w]{2,25}$/,
            message: '用户账号限制2-25位字符'
          }
        ],
        user_name: [
          { required: true, message: '请输入用户名称', trigger: ['blur', 'change'] },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]{0,25}$/,
            message: '用户名称只能是字母、数字、中文和下划线, 最多25字符'
          }
        ],
        mobile: [
          { required: false, message: '请输入联系电话', trigger: 'blur', maxlength: 64 },
          {
            pattern: /(^([0-9]{3,4}-)?[0-9]{7,8}$)|(^(0|86|17951)?1[3-9][0-9]{9}$)/,
            message: '请输入有效的电话号码'
          }
        ],
        mail: [
          { required: false, message: '请输入邮箱地址', trigger: 'blur', maxlength: 64 },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入有效的邮箱地址'
          }
        ]
      }
    }
  },
  created () {
    this.share.head_image = this.headImageUrl
  },

  props: ['ruleForm', 'headImageUrl'],

  methods: {
    beforeHeadUpload (file) {
      return RightHelper.beforeHeadImageUpload(this, file, '头像')
    },
    handleImageSuccess (res, file) {
      RightHelper.handleLoadSuccess(this, res, file, 'head_image')
    },
    handleModifyInfo () {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          const params = {
            user_name: '',
            user_gender: '',
            mobile: '',
            mail: '',
            head_image: ''
          }
          for (const k in params) {
            params[k] = this.ruleForm[k] === 'undefined' ? '' : this.ruleForm[k]
          }
          Backend.post(this, '/user/modify_info', params, undefined, undefined, undefined, true).then(data => {
            const Base64 = require('js-base64').Base64
            this.$message.success('个人资料已经成功修改')
            this.$emit('tableCloseDialog')
            this.userName = localStorage.user_name = data.user_name
            this.headImage = localStorage.head_image = data.head_image_url
            localStorage.mobile = Base64.encode(data.mobile)
            if (data.is_validated !== undefined) this.$resetSetItem('is_validated', data.is_validated)
          })
        }
      })
    }
  }
}
</script>
